import React, { useEffect, useRef, useState } from "react"
import { Container } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import JsPDF from "jspdf"
import Breadcrumbs from "../../../src/components/Common/Breadcrumb"
import { Row, Modal, Form, Canvas } from "reactstrap"

// canvas
import SignatureCanvas from "react-signature-canvas"

// images
import zithasLogo from "../../assets/images/logos/zithas_simple_logo.png"
import sign from "../../assets/images/zithas-signature.png"
import html2canvas from "html2canvas"
import configure from "configure"
import html2pdf from "html2pdf.js"
import moment from "moment"
import axios from "axios"
import Loader from "components/Common/Loader"
import secureLocalStorage from "react-secure-storage"

const ViewContract = ({ view, id }) => {
  const [fixedRightSec, setFixedRightSec] = useState(false)
  const [modal_center, setmodal_center] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 48) {
      setFixedRightSec(true)
    } else {
      setFixedRightSec(false)
    }
  })

  const params = useParams()

  const printContract = () => {
    let printContents = document.getElementById("zithasInvoicePrint").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print()
    document.body.innerHTML = originalContents
  }

  const [isLoading, setLoading] = useState(false)
  const [contract_value, setContractValue] = useState("")
  const [contract_type, setContractType] = useState("")
  const [description, setDescription] = useState("")
  const [start_date, setStartDate] = useState("")
  const [end_date, setEndDate] = useState("")
  const [note, setNote] = useState("")
  const [created_date, setCreatedDate] = useState("")
  const [sign_date, setSignDate] = useState("")
  const [symbol, setCurrencySymbol] = useState("")
  const [signature, setSignature] = useState("")
  const [contact, setContact] = useState("")

  useEffect(() => {
    FetchContractData()
  }, [])

  const FetchContractData = async () => {
    setLoading(true)
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios
        .get(`${configure.apiUrl}/contracts/${view ? id : params.id}`,{
          headers : {
            Authorization : `Bearer ${token}`
          }
        })
        .then((res) => {
          setContractValue(res.data.contract?.value	)
          setContractType(res.data.contract?.contractTypes?.contract_type)
          setStartDate(res.data.contract?.startdate)
          setEndDate(res.data.contract?.enddate)
          setNote(res.data.contract?.note)
          setDescription(res.data.contract?.template_formate)
          setCreatedDate(res.data.contract?.created_at)
          setSignDate(res.data.contract?.Date_signed)
          setCurrencySymbol(res.data.contract?.currency_symbol	)
          setSignature(res.data.contract?.signature	)
          setContact(res.data.contract?.customerDetails?.company	)
          setLoading(false)
        })
    } catch (error) {
      console.log("View Contract", error)
      setLoading(false)
    }
  }

  const navigate = useNavigate()

  const pdfRef = useRef()

  const generatePDF = async () => {
    // Select the content to be converted to PDF
    const content = pdfRef.current
    const opt = {
      margin: 0.38,
      filename: "Contract-Document.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    }

    setTimeout(() => setLoading(false), 2000)
    html2pdf().from(content).set(opt).save()
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"View Contract"} />

          <Row>
            <div className="col-md-8 ps-0">
              <div
                id="zithasInvoicePrint"
                ref={pdfRef}
                className="bg-white p-3 shadow document"
              >
                <div className="pb-4 text-center">
                  <img src={zithasLogo} height="60" alt="zithasLogo" />
                </div>
                <div>
                  <div className="mb-4">
                    {description ? (
                      <div
                        className="Features document-content"
                        dangerouslySetInnerHTML={{
                          __html: description
                            .replaceAll("{", "")
                            .replaceAll("}", ""),
                        }}
                      ></div>
                    ) : (
                      <div className="text-center">No Content Availabel</div>
                    )}
                  </div>

                  <h5 className="fw-bold text-decoration-underline">
                    Date : {moment(created_date).format("DD-MM-YYYY")}
                  </h5>
                  <Row className="mt-4 justify-space-between">
                    <div className="col-6">
                       {signature == null ? (
                        <div className="sign-box">Signature</div>
                      ) : (
                        <img src={sign} height="50" className="mb-2" />
                      )}

                      <h5>Zithas Signature</h5>
                    </div>

                    <div className="col-6 text-end">
                      {signature != null ? (
                        <>
                          <img src={signature?.signature} height="50" className="mb-2" />
                          <h5>{contact != "undefined" && contact} Signature</h5>
                        </>
                      ) : null}
                    </div>
                  </Row>
                </div>
              </div>
            </div>

            <div className="col-md-4 pe-0 ">
              <div className={`${fixedRightSec ? "fixed-right-section" : ""}`}>
                <div className="col-12  ">
                  <button
                    onClick={() => printContract()}
                    className="btn btn-sm btn-success border-radius me-1"
                  >
                    <i className="fas fa-print me-1"></i> Print
                  </button>

                  <button
                    onClick={generatePDF}
                    className="btn btn-sm btn-secondary border-radius me-1"
                  >
                    <i className="fas fa-file-download me-1"></i> Downloads
                  </button>

                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-sm btn-red border-radius"
                  >
                    <i className="fas fa-times fs-6 me-1"></i> Cancel
                  </button>
                </div>

                <div className="bg-white p-3 mt-4 shadow">
                  <h5 className="mb-4 text-dark">
                    {/* Contract Value : {contract_value && contract_value !== "" ? `${symbol} ${contract_value}` : "NA" } */}
                    Contract Value : {`${symbol} ${contract_value}` || "NA"}
                  </h5>

                  <h6 className="mb-3">
                    Start Date:{" "}
                    {start_date
                      ? moment(start_date).format("DD-MM-YYYY")
                      : "NA"}
                  </h6>
                  <h6 className="mb-3">
                    End Date:{" "}
                    {end_date ? moment(end_date).format("DD-MM-YYYY") : "NA"}
                  </h6>
                  <h6 className="mb-3">
                    Contract Type: {contract_type || "NA"}
                  </h6>
                </div>

              </div>
            </div>
          </Row>
        </Container>
      </div>
      {/* ------------ */}
    </React.Fragment>
  )
}

export default ViewContract
